// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
// require("turbolinks").start()
require("@rails/activestorage").start()
// require("channels")
import { CountUp } from "countup.js"
require("carousel")
require("menu");

(function() {
	const animationIsOkay = window.matchMedia('(prefers-reduced-motion: reduce)');
	const settlements = document.querySelectorAll("[data-settlement-number]")

	if (animationIsOkay?.matches === false) {
		settlements.forEach(function(settlement) {
			let counter = new CountUp(settlement, settlement.dataset.settlementNumber, { duration: 1.2, enableScrollSpy: true, scrollSpyOnce: true, prefix: "$", scrollSpyDelay: (Math.random() * 600) });
			counter.start();
		});
	}
})();


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// require("trix")
// require("@rails/actiontext")